import { Transition } from "@headlessui/react";
import React from "react";
import { useParams } from "react-router-dom";
import Error from "../../../common/components/error";
import Loading from "../../../common/components/loading";
import { useRecipientQuery } from "../../../graphql/generated";
import RecipientMails from "../components/mails";
import RecipientTitle from "../components/title";
import { useTitle } from "../../../common/utils/title";

const RecipientShow: React.FC = () => {
  const params = useParams();
  const [{ data, error }] = useRecipientQuery({
    variables: { id: params.recipientId ?? "" },
    pause: !params.recipientId,
  });
  useTitle(data?.recipient.email ?? params.recipientId, "Recipients");

  return (
    <>
      <Loading show={!data && !error} />
      <Error error={error} />
      <Transition
        show={!!data}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
      >
        <div className="max-w-7xl mx-auto py-4">
          <RecipientTitle recipient={data?.recipient} />
          <RecipientMails recipient={data?.recipient} />
        </div>
      </Transition>
    </>
  );
};

export default RecipientShow;
